export type AssetKind = 'fonts' | 'logos';

export const isProjectOwnedAssetUrl = (
  assetUrl: string,
  projectId: string | undefined,
  kind: AssetKind
): boolean => {
  if (!projectId) return false;
  if (!assetUrl) return false;

  try {
    const pathname: string = new URL(assetUrl, window.location.origin).pathname;
    return pathname.startsWith(`/users/${projectId}/${kind}/`);
  } catch {
    return false;
  }
};


